import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import { LayoutPublic } from '../../../layout/public';
import FieldText from '../../../components/general/fields/fieldText';
import { Dialog } from '../../../components/general/dialog/dialog';

import LoadingButtonGeneral from '../../../components/general/buttons/loadingButtonGeneral';
import { UsersMessages } from '../../../../shared/messages/usersMessages';

import { useUpdatePassword } from './hook';

export const UpdatePasswordUser = () => {
    const {
        formik,
        loading,
        step,
        user,
        showPasswordRestrictionModal,
        setShowPasswordRestrictionModal,
        handleValidateUser,
        handleValidatePassword,
        handleUpdatePassword,
    } = useUpdatePassword();

    const { usersMessages }: any = UsersMessages;

    return (
        <>
            <LayoutPublic title="Actualización de contraseña" />
            <Grid
                container
                item
                xs={12}
                mt={8}
                direction="column"
                alignItems="center"
                justifyContent="center"
                style={{ minHeight: '50vh' }}
            >
                <Box
                    style={{
                        maxWidth: '400px',
                        textAlign: 'center',
                        padding: '16px',
                    }}
                >
                    {step === 0 && (
                        <Typography
                            variant="h6"
                            style={{ marginBottom: '16px' }}
                        >
                            Para actualiza tu contraseña.
                            <br />
                            Ingresa el correo con el que inicias sesión.
                        </Typography>
                    )}
                    {step > 0 && (
                        <>
                            <Typography
                                variant="h6"
                                style={{ marginBottom: '16px' }}
                            >
                                ¡Bienvenido!, Vamos a crear una nueva
                                contraseña.
                            </Typography>
                            Elige una contraseña entre 8 y 12 caracteres con
                            letras mayúsculas, minúsculas, números y símbolos.
                            <br />
                            No uses palabras o nombres fáciles de adivinar.
                        </>
                    )}
                    <Box component="form" noValidate sx={{ mt: 1 }}>
                        <Grid container spacing={2} mt={1}>
                            <Grid item xs={12}>
                                <FieldText
                                    label="Usuario de inicio de sesión"
                                    name="email"
                                    required={true}
                                    size="small"
                                    autoComplete="email"
                                    disabled={step === 0 ? false : true}
                                    touched={formik.touched.email}
                                    errors={formik.errors.email}
                                    value={formik.values.email}
                                    onChange={(e) => {
                                        formik.setFieldTouched('email', true);
                                        formik.handleChange(e);
                                    }}
                                />
                            </Grid>
                            {step >= 1 && (
                                <Grid item xs={12}>
                                    <FieldText
                                        label="Ingresa tu contraseña anterior"
                                        name="password_current"
                                        type="password"
                                        size="small"
                                        required={true}
                                        disabled={step === 1 ? false : true}
                                        touched={
                                            formik.touched.password_current
                                        }
                                        errors={formik.errors.password_current}
                                        value={formik.values.password_current}
                                        onChange={(e) => {
                                            formik.setFieldTouched(
                                                'password_current',
                                                true
                                            );
                                            formik.handleChange(e);
                                        }}
                                    />
                                </Grid>
                            )}
                            {step === 2 && (
                                <>
                                    <Grid item xs={12}>
                                        <FieldText
                                            label="Nueva Contraseña"
                                            name="password"
                                            type="password"
                                            size="small"
                                            required={true}
                                            touched={formik.touched.password}
                                            errors={formik.errors.password}
                                            value={formik.values.password}
                                            onChange={(e) => {
                                                formik.setFieldTouched(
                                                    'password',
                                                    true
                                                );
                                                formik.handleChange(e);
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FieldText
                                            label="Confirmar Contraseña"
                                            name="password_retry"
                                            type="password"
                                            size="small"
                                            required={true}
                                            touched={
                                                formik.touched.password_retry
                                            }
                                            errors={
                                                formik.errors.password_retry
                                            }
                                            value={formik.values.password_retry}
                                            onChange={(e) => {
                                                formik.setFieldTouched(
                                                    'password_retry',
                                                    true
                                                );
                                                formik.handleChange(e);
                                            }}
                                        />
                                    </Grid>
                                </>
                            )}
                            <Grid item xs={12}>
                                {step === 0 && (
                                    <LoadingButtonGeneral
                                        onClick={handleValidateUser}
                                        title={'Verificar usuario'}
                                        disabled={
                                            !formik.values.email ||
                                            !!formik.errors.email
                                        }
                                        loading={loading}
                                        sx={{ mr: 1 }}
                                    />
                                )}
                                {step === 1 && (
                                    <LoadingButtonGeneral
                                        onClick={handleValidatePassword}
                                        title={'Validar contraseña'}
                                        disabled={
                                            !formik.values.password_current ||
                                            !!formik.errors.password_current
                                        }
                                        loading={loading}
                                        sx={{ mr: 1 }}
                                    />
                                )}
                                {step === 2 && (
                                    <LoadingButtonGeneral
                                        onClick={handleUpdatePassword}
                                        title={'Guardar'}
                                        disabled={
                                            !formik.values.password ||
                                            !formik.values.password_retry ||
                                            !!formik.errors.password ||
                                            !!formik.errors.password_retry
                                        }
                                        loading={loading}
                                        sx={{ mr: 1 }}
                                    />
                                )}
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Grid>
            <Dialog
                title="Actualización de contraseña no disponible"
                open={showPasswordRestrictionModal}
                onClose={() => setShowPasswordRestrictionModal(false)}
            >
                <Grid
                    container
                    item
                    xs={12}
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Box
                        style={{
                            maxWidth: '500px',
                            textAlign: 'left',
                            padding: '16px',
                        }}
                    >
                        <Typography variant="body1" paragraph>
                            Lo sentimos,{' '}
                            {usersMessages.PASSWORD_UPDATE_FORBIDDEN}
                        </Typography>

                        <Box
                            style={{
                                background: '#f8f9fa',
                                padding: '12px',
                                borderRadius: '8px',
                                marginTop: '8px',
                                marginBottom: '16px',
                            }}
                        >
                            <Typography
                                variant="subtitle2"
                                style={{ marginBottom: '6px', fontWeight: 500 }}
                            >
                                Por favor:
                                <ol
                                    style={{
                                        marginTop: 0,
                                        paddingLeft: '20px',
                                    }}
                                >
                                    <li style={{ marginBottom: '6px' }}>
                                        Contacta al administrador del sistema
                                    </li>
                                    <li style={{ marginBottom: '6px' }}>
                                        Solicita que habiliten la actualización
                                        de contraseña
                                    </li>
                                    <li>
                                        Proporciona tu correo registrado:{' '}
                                        <strong>{user?.username}</strong>
                                    </li>
                                </ol>
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
            </Dialog>
        </>
    );
};
